import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import es from 'react-phone-input-2/lang/es.json'

export default function InputPhone ({className, value, onChange, onBlur, name, disabled} : {className: string, value: any, onChange: (phone: string) => void, onBlur: any, name: string, disabled: boolean}){
    return(
        <PhoneInput
            dropdownClass='dropdown-phone'
            containerClass='label-input' 
            inputClass={className}
            localization={es} 
            inputStyle={{display: 'flex', background: 'rgba(27, 27, 27, 0.05)', padding: '16px 0px 10px 48px', border: 'none', borderRadius: '0', width: '100%', height: '100%', fontFamily: 'Poppins', fontSize: '14px', fontWeight: '400'}} 
            country={'sv'}
            value={value}
            onChange={(phone) => {onChange(phone)}}
            enableSearch = {true}
            onBlur={onBlur}
            inputProps={{name: name}}
            disabled = {disabled}
        />
    )
}